import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-process-charts',
    templateUrl: './process-charts.component.html',
    styleUrls: ['./process-charts.component.scss'],
    standalone: false
})
export class ProcessChartsComponent {

}
